angular.module('SpidApp')

.constant('TransactionAdapterConfig', {
  name : 'Transaction',
  fields : [
    {
      local   : 'id',
      distant : 'id'
    }, {
      local   : 'vacation_id',
      distant : 'vacation_id'
    }, {
      local   : 'bill',
      distant : 'bill'
    }, {
      local   : 'finished',
      distant : 'finished'
    }, {
      local   : 'username',
      distant : 'username'
    }, {
      local   : 'updated_at',
      distant : 'updated_at'
    }, {
      local   : 'agency_id',
      distant : 'agency_id'
    }, {
      local   : 'last_iso_sync_date',
      distant : 'last_iso_sync_date'
    }
  ]
})
